import React from 'react';
import { useTranslation } from 'react-i18next';

function EmailInvitations({ assignments }) {
  const { t } = useTranslation();

  const handleSendInvitations = () => {
    // Logic to send email invitations
    console.log('Sending invitations...');
    console.log('Assignments:', assignments);
    // For now, just a placeholder. Actual email sending logic will be implemented later.
    // Email functionality is now handled in the PublishedEventSummary page
  };

  return (
    <div>
      <h3 className="text-xl font-bold mb-2">{t('emailInvitations.title')}</h3>
      <p className="mb-4">{t('emailInvitations.description')}</p>
      <div className="mt-4">
        <h3 className="text-xl font-bold mb-2">{t('emailInvitations.assignmentsOverview')}</h3>
        {assignments && assignments.length > 0 ? (
          <ul>
            {assignments.map((assignment, i) => (
              <li key={i}>
                {t('emailInvitations.buysFor', { giver: assignment.giver, receiver: assignment.receiver })}
              </li>
            ))}
          </ul>
        ) : (
          <p>{t('emailInvitations.noAssignments')}</p>
        )}
      </div>
      <button onClick={handleSendInvitations} className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded mt-4">
        {t('emailInvitations.sendButton')}
      </button>
    </div>
  );
}

export default EmailInvitations;
